module.exports = __webpack_public_path__ + "img/077e10a7a4fac68d9cb87f4a1f050e99.png";